import React from 'react';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import EcoFaqWithImg from 'eco-design/sections/eco-faq-win-img';
import SmartLoad from '../../../components/SmartLoad';
import EcoImg from 'eco-design/base/eco-img';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import getLocal from '@/app/utils/getLocal';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import Retradant from './icons/Retradant';
import Protection from './icons/Protection';
import Backfeed from './icons/Backfeed';
import Drop from './icons/Drop';
import Battery from './icons/Battery';
import Data from './icons/Data';

const SectionCardEngineer = () => {
    const { t } = useLang('theProduct.SectionCardEngineer');

    const { locale } = getLocal();

    const icons = [
        {
            icon: <Retradant />,
            title: t('icon_title_1'),
            desc: t('icon_desc_1'),
        },
        {
            icon: <Protection />,
            title: t('icon_title_2'),
            desc: t('icon_desc_2'),
        },
        {
            icon: <Backfeed />,
            title: t('icon_title_3'),
            desc: t('icon_desc_3'),
        },
        {
            icon: <Drop />,
            title: t('icon_title_4'),
            desc: t('icon_desc_4'),
        },
        {
            icon: <Battery />,
            title: t('icon_title_5'),
            desc: t('icon_desc_5'),
        },
        {
            icon: <Data />,
            title: t('icon_title_6'),
            desc: t('icon_desc_6'),
        },
    ];

    const sec2Items = [
        {
            title: t('sec2_item1_title'),
            desc: t('sec2_item1_desc'),
        },
        {
            title: t('sec2_item2_title'),
            desc: t('sec2_item2_desc'),
        },
        {
            title: t('sec2_item3_title'),
            desc: t('sec2_item3_desc'),
        },
    ];

    const isNA = ['us', 'ca'].includes(locale);

    const card1ImgObj = isNA
        ? {
              pc: 'https://websiteoss.ecoflow.com/upload/image/1745997358617/%E5%AE%A2%E5%8E%85-pc.jpg',
              pad: 'https://websiteoss.ecoflow.com/upload/image/1745997358792/%E5%AE%A2%E5%8E%85-h5.jpg',
              h5: 'https://websiteoss.ecoflow.com/upload/image/1745997358792/%E5%AE%A2%E5%8E%85-h5.jpg',
          }
        : {
              pc: 'https://websiteoss.ecoflow.com/upload/image/1745651273261/EF_LS_PS_EU_EXP04.2025_10_RGB%20(1).jpg',
              pad: 'https://websiteoss.ecoflow.com/upload/image/1745651273261/EF_LS_PS_EU_EXP04.2025_10_RGB%20(1).jpg',
              h5: 'https://websiteoss.ecoflow.com/upload/image/1745737541530/Frame%201612706796.jpg',
          };

    return (
        <section className={styles.SectionCardEngineer}>
            <div className="section-img-container">
                <div className="section-img-title">{t('section_title_1')}</div>
                <div className="section-img-subtitle">{t('section_desc_1')}</div>
                <div className="section-img">
                    <EcoImg pc={card1ImgObj.pc} pad={card1ImgObj.pad} h5={card1ImgObj.h5} isOpenLazy></EcoImg>
                </div>
                {!isNA && (
                    <div className="icons-wrapper">
                        {icons.map((icon, index) => {
                            return (
                                <div className="icon-wrapper" key={icon.title + index}>
                                    {icon.icon}
                                    <div className="title">{icon.title}</div>
                                    <div className="desc">{icon.desc}</div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            <EcoSpace hPc="160px" hPad="100px" />

            <EcoSectionCard
                className="section-card section-card_1"
                layout="img-right"
                pc="https://websiteoss.ecoflow.com/upload/image/1745227112550/pc-engineer-sec2-1.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1745227112550/pc-engineer-sec2-1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1745227112151/m-engineer-sec2-1.jpg"
                subTitle={t('section_desc_2')}
                theme="white"
                title={t('section_title_2')}
                desc={
                    <div className="sec2s">
                        {sec2Items.map((item, index) => {
                            return (
                                <div className="sec2-wrapper" key={item.title + index}>
                                    <div className="title">{item.title}</div>
                                    <div className="desc">{item.desc}</div>
                                </div>
                            );
                        })}
                    </div>
                }
            />
            <EcoSpace hPc="160px" hPad="100px" />
            <EcoSectionCard
                className="section-card"
                desc={t('section_desc_3')}
                layout="img-left"
                pc="https://websiteoss.ecoflow.com/upload/image/1745227112350/pc-engineer-sec3-1.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1745227112350/pc-engineer-sec3-1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1745227113413/m-engineer-sec3-1.jpg"
                subTitle=""
                theme="white"
                title={t('section_title_3')}
            />
            <EcoSpace hPc="160px" hPad="100px" />
            <div className="section-card-faq-title1">{t('section_title_3_1')}</div>
            {/* <div className="section-card-faq-box"> */}
            <EcoFaqWithImg
                className="section-card-faq"
                items={[
                    {
                        desc: t('section_desc_4'),
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745227111953/pc-engineer-sec4-1.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745227111953/pc-engineer-sec4-1.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745227113197/m-engineer-sec4-1.jpg',
                        title: t('section_title_4'),
                    },
                    {
                        desc: t('section_desc_5'),
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745227113592/pc-engineer-sec4-2.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745227113592/pc-engineer-sec4-2.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745227112993/m-engineer-sec4-2.jpg',
                        title: t('section_title_5'),
                    },
                ]}
            />
            {/* </div> */}
        </section>
    );
};

export default SectionCardEngineer;
